import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-redflag",
  "use": "icon-redflag-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"icon-redflag\">\r\n<path fill-rule=\"evenodd\" fill=\"rgb(222, 0, 17)\" d=\"M2.000,-0.000 L18.000,-0.000 C19.104,-0.000 20.000,0.895 20.000,2.000 L20.000,18.000 C20.000,19.105 19.104,20.000 18.000,20.000 L2.000,20.000 C0.895,20.000 -0.000,19.105 -0.000,18.000 L-0.000,2.000 C-0.000,0.895 0.895,-0.000 2.000,-0.000 Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol